module.exports = __webpack_public_path__ + "static/img/index-7-1.087988d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index-7-1.png
// module id = KXyx
// module chunks = 23